/* unplugin-vue-components disabled */import { render } from "./comp7.vue?vue&type=template&id=892c7f96&scoped=true"
import script from "./comp7.vue?vue&type=script&lang=js"
export * from "./comp7.vue?vue&type=script&lang=js"

import "./comp7.vue?vue&type=style&index=0&id=892c7f96&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-892c7f96"]])

export default __exports__